import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompare = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgCompare" data-sentry-source-file="compare.tsx">
    <g clipPath="url(#compare_svg__a)" data-sentry-element="g" data-sentry-source-file="compare.tsx">
      <path fill="#263E6A" d="m8 19.308-.708-.714 3.095-3.094H2.5v-1h7.887l-3.095-3.094.708-.714L12.308 15zm8-6L11.692 9 16 4.692l.708.714L13.614 8.5H21.5v1h-7.886l3.094 3.094z" data-sentry-element="path" data-sentry-source-file="compare.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="compare.tsx">
      <clipPath id="compare_svg__a" data-sentry-element="clipPath" data-sentry-source-file="compare.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="compare.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgCompare;